import { useQuery } from '@tanstack/react-query';
import { ActivityLogParams, getActivityLogs } from 'src/api/activityLogsApi';
import { queryFilter } from 'src/utils/proptypes';

export const ActivityLogQueryKeys = {
   GetActivityLogs: 'getActivityLogs',
   ExportActivityLogsFile: 'exportActivityLogsFile',
};

export const useGetActivityLogs = (query: queryFilter & ActivityLogParams) => {
   return useQuery({
      queryKey: [ActivityLogQueryKeys.GetActivityLogs, query],
      queryFn: () => getActivityLogs(query),
      staleTime: Infinity,
      retry: 0,
      placeholderData: prev => prev,
   });
};
